// extracted by mini-css-extract-plugin
export default {"navLink":"DocumentTable_navLink__S4jO7"};